module.exports = __webpack_public_path__ + "static/media/piraua2.291870bd.jpg";